import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private connection: WebsocketConnection;

  constructor() {
    this.connection = null;
  }

  setup(): WebsocketConnection {

    if (!this.connection) {
      let loc = window.location;
      let uri = loc.protocol === "https:" ? "wss:" : "ws:";
      uri += "//" + loc.host + "/ws";

      this.connection = new WebsocketConnection(new WebSocket(uri));
    }
    return this.connection;

  }

  //   function __handleConnection(scene: Scene) {
  //     let switchboard = new ClientSwitchboard();
  //     let entityManager = new EntityManager(scene, switchboard);

  //     switchboard.onNotification.subscribe(notification => {
  //         let msg = new TextElement(false, true, 'headerText');
  //         msg.position = vec3.fromValues(0, 200, 0);
  //         msg.text = notification.message;
  //         scene.textManager.addText(msg, 2500);
  //     });

  //     let loc = window.location;
  //     let uri = loc.protocol === "https:" ? "wss:" : "ws:";
  //     uri += "//" + loc.host + "/ws";

  //     let socket = new WebSocket(uri);
  //     socket.binaryType = "arraybuffer";
  //     socket.onopen = () => {
  //         switchboard.init();
  //     };
  //     socket.onmessage = (e) => {
  //         switchboard.processRawData(new Uint8Array(e.data));
  //     };

  //     switchboard.onPacketEmitted.subscribe(packet => {
  //         socket.send(packet.write());
  //     });

  //     $("#userInput").keydown(e => {
  //         let val = $("#userInput").val().toString();
  //         if (e.keyCode == 13 && val) {

  //             let commandPacket = new IssueCommandRequestPacket();
  //             commandPacket.command = val;

  //             switchboard.send(commandPacket);

  //             $("#userInput").val('');
  //         }
  //     })
  // }

}

class WebsocketConnection {
  connected: Subject<boolean>;
  received: Subject<Uint8Array>;

  constructor(private socket: WebSocket) {

    this.connected = new Subject;
    this.received = new Subject;

    socket.binaryType = "arraybuffer";
    socket.onopen = () => {
      this.connected.next(true);
    };
    socket.onmessage = (e) => {
      this.received.next(new Uint8Array(e.data))
    };
  }

  send(data: Uint8Array) {
    this.socket.send(data);
  }
}